import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import {
  CountryCallingCode,
  CountryCode,
  getCountryCallingCode,
  parsePhoneNumber
} from 'libphonenumber-js/max'
import { delay } from 'rxjs/operators'
import {
  KcDataService  
} from '../../../kc-data.service'
import { KcEnterTelephoneViewData } from '../../../interfaces/kc-data.interface'
@Component({
  selector: 'customer-portal-revolution-enter-telephone',
  templateUrl: './revolution-enter-telephone.component.html'
})
export class RevolutionEnterTelephoneComponent implements OnInit {
  constructor(
    private readonly kcDataService: KcDataService,
    public transifexService: TransifexService,
    public remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.mobilePrefixCountries =
    this.remoteConfigService.get('b2c.mobileCountryPrefixes')
  }

  @ViewChild('enterTelephoneForm', { static: true })
  private readonly formRef: ElementRef

  public form = new FormGroup({
    mobilePrefix: new FormControl<string | null>(null),
    mobile: new FormControl<string | null>(null, [
      control => {
        if (!control || !this.form || !control.value) {
          return {}
        }

        if (!this.form.value.mobilePrefix) {
          return { invalidNumber: true }
        }

        if (control.value.length < 2) {
          return { invalidNumber: true }
        }

        const telephoneNumber: string =
          this.form.value.mobilePrefix + control.value

        const prefix: string = this.form.value.mobilePrefix
        const prefixEntry = Object.entries(this.mobilePrefixes).find(entry => {
          return entry[1] === prefix.substr(1)
        })
        const prefixCountry = prefixEntry[0] as CountryCode

        let parsed = null
        try {
          parsed = parsePhoneNumber(telephoneNumber, prefixCountry)
        } catch {
          return { invalidNumber: true }
        }

        if (!parsed.isPossible()) {
          return { invalidNumber: true }
        }

        if (!parsed.isValid()) {
          return { invalidNumber: true }
        }

        if (!Number(control.value)) {
          return { invalidNumber: true }
        }

        const numberType = parsed.getType()
        if (numberType !== 'MOBILE') {
          return { notMobile: true }
        }

        return {}
      }
    ])
  })

  public viewData: KcEnterTelephoneViewData
  private readonly mobilePrefixCountries: string[]
  public mobilePrefixes: { [key: string]: CountryCallingCode } = {}
  public submitting: boolean
  public telephone: string | null

  ngOnInit(): void {
    this.viewData = this.kcDataService.getViewData() as KcEnterTelephoneViewData

    // fill calling codes
    for (const countryCodeIndex in this.mobilePrefixCountries) {
      const countryCode = this.mobilePrefixCountries[countryCodeIndex]
      this.mobilePrefixes[countryCode] = getCountryCallingCode(
        countryCode as CountryCode
      )
    }

    // preselect prefix
    if (this.mobilePrefixCountries.length === 1) {
      this.form.patchValue({
        mobilePrefix: '+' + this.mobilePrefixes[this.mobilePrefixCountries[0]]
      })
    }

    // validate again after changing prefix
    this.form.controls.mobilePrefix.valueChanges
      .pipe(delay(1))
      .subscribe(prefix => {
        this.form.controls.mobile.updateValueAndValidity()
      })

    // If 0 is in the first letter, remove it on post request
    this.form.valueChanges.subscribe(value => {
      if (value?.mobile?.[0]) {
        this.telephone =
          value.mobilePrefix +
          (value.mobile[0] === '0' ? value.mobile.substr(1) : value.mobile)
      } else {
        this.telephone = undefined
      }
    })
  }

  public submit(): void {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }
}
